import React from 'react'
import "./feqSection.css"
import FAQ from '../../../components/FAQ'
function FAQSection() {

  const faqsArr = [
    {
      quest: "What makes this 150-question program different from other DSA resources?",
      ans: "Our program focuses on high-impact questions that build foundational skills and problem-solving techniques specifically tailored for FANG and top tech interviews. Unlike other resources, which might overwhelm you with thousands of questions."
    },
    {
      quest: "Is this program suitable for beginners?",
      ans: "Yes! The program is designed for both beginners and experienced coders. Each question comes with hints and solutions to help you learn and progress, regardless of your current skill level."
    },
    {
      quest: "How much time will it take to complete the 150 questions?",
      ans: "This depends on your schedule and learning pace, but many users find they can complete the program within 1-2 months by dedicating just a few hours a week. For best results, we recommend focusing on understanding the concepts rather than rushing through the questions."
    },
    {
      quest: "Can I access the program on mobile or tablet?",
      ans: "Absolutely! Our program is fully accessible on any device, whether it’s a mobile phone, tablet, or desktop. You can practice whenever and wherever it’s convenient for you."
    },
    {
      quest: "What if I get stuck on a question?",
      ans: "Each question is designed to challenge you, but you’ll also have access to hints and solutions to guide you. The solutions provide clear explanations to help you understand the logic and approach behind each answer, ensuring you learn effectively."
    },
    {
      quest: "Is there a refund policy?",
      ans: "Yes, we offer a 3-day satisfaction guarantee. If you’re not fully satisfied with the program, contact our support team within 3 days of purchase for assistance."
    },
    {
      quest: "Is there a time limit on accessing the program?",
      ans: "Once you sign up, you’ll have lifetime access to the 150 questions. This means you can revisit questions, review solutions, and practice at your own pace without any time restrictions."
    },
    {
      quest: "Can this program help with other tech company interviews besides FANG?",
      ans: "Definitely! While the program is focused on preparing for FANG interviews, the problem-solving skills and core concepts covered are essential for technical interviews at any major tech company. This program is designed to help you succeed in interviews with a wide range of tech giants."
    },
    {
      quest: "How do I get started?",
      ans: "Getting started is easy! Just click on the “Buy Now” button, and for a limited time, get access to all 150 questions at just ₹2 per question. Once purchased, you’ll have instant access to the entire program."
    },
    {
      quest: "What payment methods do you accept?",
      ans: "We accept various secure payment methods, including credit/debit cards, UPI, and popular digital wallets. Your payment details are safe and encrypted to ensure a smooth transaction."
    },
    

  ]

  


  return (
    <section id='faqSection' className='faq-section'>
        <div className='card-wp'>
        <div className='card'>
          <h1 className='text rubik-gfont'>Frequently asked questions</h1>
        </div>
        </div>
        
        <div className='faq-wp'>
        <FAQ faqsArr={faqsArr} />
        </div>
    </section>
  )
}

export default FAQSection